<script>
import Layout from "../../layouts/main";
import {cloneDeep} from 'lodash';

export default {
  page: {
    title: "Campaigns",
    meta: [{name: "description", content: ''}],
  },
  components: {
    Layout,
  },
  data() {
    return {
      title: "Campaigns",
      showModal: false,
      currentPage: 1,
      pageSize: 10,
    };
  },
  computed: {
    campaigns() {
      const campaigns = cloneDeep(this.$store.state.campaign.campaigns)
      return campaigns.sort((a, b) => a.progress - b.progress)
    },
    paginatedCampaigns() {
      return this.campaigns.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
    },
  },
  methods: {
    scrollUp() {
      window.scrollTo(0,0);
    },
  }
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">{{ $t('Signed campaigns') }}</h4>
            <!-- Campaigns table -->
            <div class="table-responsive mb-0">
              <table class="table table-centered table-nowrap text-center">
                <thead class="thead-light">
                <tr>
                  <th class="text-left">{{ $t('Campaign') }}</th>
                  <th class="text-right">{{ $t('Total posts') }}</th>
                  <th class="text-right">{{ $t('Published posts') }}</th>
                  <th class="text-right">{{ $t('Income') }}</th>
                  <th>{{ $t('Progress') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="campaign in paginatedCampaigns" :key="campaign.campaign_id">
                  <td class="text-left">
                    {{ campaign.campaign_name }}
                  </td>
                  <td class="text-right">{{ campaign.total_posts }}</td>
                  <td class="text-right">{{ campaign.published_posts }}</td>
                  <td class="text-right">
                    &euro;{{ campaign.profit }}
                  </td>
                  <td>
                    <b-progress :max="100">
                      <b-progress-bar :value="campaign.progress * 100" :label="`${(campaign.progress * 100).toFixed(0)}%`"></b-progress-bar>
                    </b-progress>
                  </td>
                </tr>
                </tbody>
              </table>
              <b-modal v-model="showModal" title="Coca-Cola kampanja" centered>
                <p class="mb-2">
                  {{ $t('Coca-cola campaign ID') }}
                  <span class="text-primary">#SK2540</span>
                </p>
                <p class="mb-4">
                  {{ $t('Client') }}
                  <span class="text-primary">Coca-cola Hellenic</span>
                </p>
              </b-modal>
            </div>
            <!-- end table -->
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <b-pagination
            v-if="campaigns.length > 0"
            class="justify-content-center"
            pills
            v-model="currentPage"
            @input="scrollUp"
            :total-rows="campaigns.length"
            :per-page="this.pageSize"
            aria-controls="my-table"
        ></b-pagination>
      </div>
    </div>
  </Layout>
</template>
